import e from"react";var r=e.createContext({overflowTolerance:0});export{r as TypographyContext};
//# sourceMappingURL=TypographyContext.js.map
